<app-section-header [text]="header">
    <ng-container buttons>
        <div class="bg-white shadow-lg p-2 flex flex-row gap-2 items-center rounded-full">
            <button class="btn btn-sm btn-primary text-sm px-5 rounded-full" matTooltip="Create" (click)="openInput()">
                <iota-icon icon="plus"></iota-icon>
                <span i18n>Upload</span>
            </button>
        </div>
        <input id="fileInput" hidden type="file" (change)="selectFile($event)" />
    </ng-container>
</app-section-header>

<div class="alert alert-info" *ngIf="(documents$ | ngrxPush).length === 0" i18n>No documents available.</div>
<div class="flex flex-col gap-2 items-stretch">
    <div *ngFor="let attachment of documents$ | ngrxPush" class="border rounded-xl shadow-md p-2 flex flex-row items-center gap-2">
        <div class="h-10 w-10 cursor-pointer flex justify-center items-center bg-gray-300 rounded-lg" (click)="showDocument(attachment)">
            <img *ngIf="isImage(attachment)" class="w-full rounded-lg" [src]="attachment.url" />
            <iota-icon class="rounded-lg" *ngIf="!isImage(attachment)" size="2x" [src]="getFileIconPath(attachment)"></iota-icon>
        </div>
        <button (click)="showDocument(attachment)">
            {{ attachment.name }}
        </button>
        <div class="flex-1"></div>
        <div class="flex flex-row items-center gap-1" *ngIf="labelSelection">
            <div *ngFor="let label of getShowableLabels(attachment)" class="badge bg-iota-draft text-gray-500 border-none">
                {{ getLabelDescription(label) }}
            </div>
        </div>
        <span>
            {{ attachment.creationDateTime | date: 'yyyy-MM-dd HH-mm' }}
        </span>
        <div (click)="download(attachment)" class="btn btn-primary rounded-xl">
            <iota-icon icon="document-arrow-down"> </iota-icon>
        </div>
        <div class="btn btn-error rounded-xl" (click)="removeAttachment(attachment)">
            <iota-icon icon="trash"> </iota-icon>
        </div>
    </div>
</div>
